import LandingPage from "./pages/Landing";

export default function App() {
  return (
    <section className="flex flex-col w-full h-full justify-center items-center gap-4">
      <LandingPage />
    </section>
  );
}
